// Backend emits a stable type_code; the frontend owns the display label so there
// is one translation system. Unknown/missing code falls back to a neutral "Item"
// label (shop.typeLabel.item) — the raw code is never shown to the user.
export const shopTypeLabel = (code, t) =>
  t(`shop.typeLabel.${code || "item"}`, { defaultValue: t("shop.typeLabel.item") });
